export function duplicateObject<T>(obj: T): T {
  return JSON.parse(JSON.stringify(obj))
}

export function JSONparse(json: string): unknown {
  try {
    return JSON.parse(json)
  } catch {
    return {}
  }
}
